import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Box, Button, Container, Link } from '@mui/material';
import { useState } from 'react';

// import { useRouter } from 'next/router';
import CustomButton from '../ui/CustomButton';

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const FinCENBoirSubMenu = () => {
  // const router = useRouter();
  const [selectedSubMenu, setSelectedSubMenu] = useState('');

  // function getActiveClassName(currentPath: string[]) {
  //   const pathName = router.pathname;
  //   if (pathName === '/' && currentPath.includes('/')) {
  //     return 'Mui-second-level-selected-menu';
  //   }
  //   const matchingPaths = currentPath.filter((p) => pathName === p);
  //   if (matchingPaths.length > 0 && !currentPath.includes('/'))
  //     return 'Mui-second-level-selected-menu';
  //   return '';
  // }

  // handle click for Sub Menu in Mobile view
  function getSubMenuHoverClassName(currentSubMenu: string) {
    if (
      currentSubMenu !== undefined &&
      currentSubMenu !== '' &&
      selectedSubMenu !== undefined &&
      selectedSubMenu !== '' &&
      selectedSubMenu === currentSubMenu
    ) {
      return 'dropdown-menu button-hover';
    }
    return 'dropdown-menu';
  }

  function toggleSelectedSubMenu(currentSubMenu: string) {
    if (selectedSubMenu !== undefined && selectedSubMenu !== '') {
      if (currentSubMenu !== selectedSubMenu) {
        setSelectedSubMenu(currentSubMenu);
      } else {
        setSelectedSubMenu('');
      }
    } else {
      setSelectedSubMenu(currentSubMenu);
    }
  }
  return (
    <Box
      sx={{
        backgroundColor: 'rgba(235, 235, 235, 0.85)',
        backdropFilter: 'saturate(50%) blur(5px)',
        borderBottom: '1px solid #dcdcdc',
        py: 1,
        px: 3,
        color: '#14181f',
        textAlign: 'right',
        position: 'sticky',
        left: 0,
        right: 0,
        top: 64,
        zIndex: 999,
        minHeight: { sm: 50, md: 54 },
        display: { xs: 'none', sm: 'flex' },
        justifyContent: 'flex-end',
        '& a:hover': { backgroundColor: 'transparent' },
      }}
      component="nav"
      aria-label="Secondary Navigation"
    >
      <Container maxWidth="lg" sx={{ p: '0 !important', display: 'flex' }}>
        <CustomButton
          href="/efile-boi-report/"
          text="FinCEN BOI <br /> Report"
          custom="margin-right:0px; line-height:1.2; padding-top:0px; padding-bottom:0px; text-align:left;"
          icon={
            <Box
              component="img"
              src="/assets/images/boi-icon.png"
              alt="FinCEN Boi Reporting Forms"
              sx={{ width: { sm: 32, md: 36 }, height: { sm: 32, md: 36 } }}
            />
          }
          sm="12px"
          md="14px"
        />
        <Box sx={{ flexGrow: 1 }} />
        <CustomButton
          href="/resources/fincen-boir/boi-reporting-instructions/"
          text="BOIR Instructions"
          sm="12px"
          md="14px"
        />
        <CustomButton
          href="/resources/fincen-boir/boi-reporting-due-dates/"
          text="BOIR Due Dates"
          sm="12px"
          md="14px"
        />
        <CustomButton
          href="#deadlines"
          text="Filing Deadline"
          sm="12px"
          md="14px"
        />
        <Box
          className={getSubMenuHoverClassName('btn-boir-resources')}
          onMouseLeave={() => setSelectedSubMenu('')}
        >
          <Button
            id="btn-boir-resources"
            onClick={() => toggleSelectedSubMenu('btn-boir-resources')}
            aria-haspopup="true"
            endIcon={<KeyboardArrowDownIcon sx={{ ml: -1 }} />}
            sx={{
              textTransform: 'none',
              backgroundColor: 'transparent',
              color: '#444',
              ml: 1,
              fontSize: { sm: 12, md: 14 },
              '&:hover, &:focus': {
                backgroundColor: 'rgba(33, 62, 153, 0.04)',
                color: '#213e99',
              },
            }}
          >
            Resources
          </Button>
          <Box
            className="tzo-dropdown"
            sx={{
              width: 320,
              left: 'auto !important',
              right: 0,
              '&:before': { right: 50 },
            }}
          >
            <Box component="ul">
              <li>
                <Link href="/resources/fincen-boir/company-applicant-vs-beneficial-owner/">
                  Company Applicant VS Beneficial Owners
                </Link>
              </li>
              <li>
                <Link href="/resources/fincen-boir/boir-penalties/">
                  Penalties and Charges
                </Link>
              </li>
            </Box>
          </Box>
        </Box>
        <CustomButton
          href="/pricing/#boir"
          text="Pricing"
          sm="12px"
          md="14px"
        />
        {/* <CustomButton
          href="/tools/boir-submission-status/"
          text="BOIR Submission Status"
          sm="12px"
          md="14px"
        /> */}
      </Container>
    </Box>
  );
};

export default FinCENBoirSubMenu;
